import { getValue } from "../../../common/getValue";

export function LOYALTY_ITEM_REQUEST(state) {
  state;
  state.loyaltyItems = {
    ...state.loyaltyItems,
    isLoading: true
  };
}
export function LOYALTY_ITEM_SUCCESS(state, payload) {
  const data = [];
  payload.data.data.loyaltyItems.rows.map(item => {
    data.push({
      id: item._id || "-",
      name: getValue(item, 'name', '-'),
      price: getValue(item, 'price', 0),
      imageURL: getValue(item, 'imageURL', '-'),
      description: getValue(item, 'description', '-'),
    });
    return item;
  });
  state;
  state.loyaltyItems = {
    data: data,
    count: payload.data.data.loyaltyItems.count,
    status: payload.data.status,
    isLoading: false
  };
}
export function LOYALTY_ITEM_ERROR(state, payload) {
  state;
  state.loyaltyItems = {
    ...state.loyaltyItems,
    isLoading: false,
    error: true,
    errorMessage: payload
  };
}

export function GET_LOYALTY_ITEM_REQUEST(state) {
  state;
  state.loyaltyItem = {
    ...state.loyaltyItem,
    isLoading: true
  };
}
export function GET_LOYALTY_ITEM_SUCCESS(state, payload) {
  const { data } = payload.data;
  const dataResponse = {
    id: data._id || "-",
    name: getValue(data, 'name', '-'),
    price: getValue(data, 'price', 0),
    categoryKey: getValue(data, 'categoryKey', 0),
    imageURL: getValue(data, 'imageURL', '-'),
    description: getValue(data, 'description', '-'),
  };
  state;
  state.loyaltyItem = {
    isLoading: false,
    data: dataResponse
  };
}
export function GET_LOYALTY_ITEM_ERROR(state, payload) {
  state;
  state.loyaltyItem = {
    isLoading: false,
    error: true,
    errorMessage: payload
  };
}

export function CREATE_LOYALTY_ITEM_REQUEST(state) {
  state;
  state.loyaltyItem = {
    ...state.loyaltyItem,
    isLoading: true
  };
}
export function CREATE_LOYALTY_ITEM_SUCCESS(state, payload) {
  state;
  state.loyaltyItems = {
    isLoading: false,
    data: [...state.loyaltyItems.data, payload.data],
    status: payload.status
  };
  state.loyaltyItem = {
    ...state.loyaltyItem,
    isLoading: false
  };
}
export function CREATE_LOYALTY_ITEM_ERROR(state, payload) {
  state;
  state.loyaltyItems = {
    isLoading: false,
    error: true,
    errorMessage: payload
  };
}

export function EDIT_LOYALTY_ITEM_REQUEST(state) {
  state;
  state.loyaltyItem = {
    ...state.loyaltyItem,
    isLoading: true
  };
}
export function EDIT_LOYALTY_ITEM_SUCCESS(state) {
  state;
  state.loyaltyItem = {
    ...state.loyaltyItem,
    isLoading: false
  };
}
export function EDIT_LOYALTY_ITEM_ERROR(state, payload) {
  state;
  state.isLoading = false;
  state.error = true;
  state.errorMessage = payload;
}

export function DELETE_LOYALTY_ITEM_REQUEST(state) {
  state;
  state.loyaltyItems = {
    ...state.loyaltyItems,
    isLoading: true
  };
}
export function DELETE_LOYALTY_ITEM_SUCCESS(state, payload) {
  let index = state.loyaltyItems.data.findIndex(item => item.id == payload);
  state.loyaltyItems.data.splice(index, 1);
  state;
  state.loyaltyItems = {
    ...state.loyaltyItems,
    isLoading: false,
    data: state.loyaltyItems.data
  };
}
export function DELETE_LOYALTY_ITEM_ERROR(state, payload) {
  state.loyaltyItems = {
    ...state.loyaltyItems,
    isLoading: false,
    error: true,
    errorMessage: payload,
  }
}

export function LOYALTY_ITEM_CATEGORY_REQUEST(state) {
  state;
  state.loyaltyItemCategory = {
    ...state.loyaltyItemCategory,
    isLoading: true
  };
}
export function LOYALTY_ITEM_CATEGORY_SUCCESS(state, payload) {
  const data = [];
  payload.data.data.itemCategories.rows.map(item => {
    data.push({
      _id: item._id || "-",
      key: getValue(item, 'key', '-'),
      value: getValue(item, 'value', '-'),
    });
    return item;
  });
  state;
  state.loyaltyItemCategory = {
    data: data,
    count: payload.data.data.itemCategories.count,
    status: payload.data.status,
    isLoading: false
  };
}
export function LOYALTY_ITEM_CATEGORY_ERROR(state, payload) {
  state;
  state.adminAndStaff = {
    ...state.loyaltyItemCategory,
    isLoading: false,
    error: true,
    errorMessage: payload
  };
}